import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const CloneStampStroke = z.object({
    maskImage: anyImageOpResult,
    maskOffset: vector2Like,
    sourceOffset: vector2Like,
})

export type CloneStampStroke = z.infer<typeof CloneStampStroke>

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            drawMaskOnly: z.boolean(),
            strokes: z.array(CloneStampStroke),
        }),
    },
}
